import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "custom-h5" }
const _hoisted_2 = { class: "custom-h5__layout" }
const _hoisted_3 = { class: "custom-h5__layout__showNav" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "custom-h5__layout__showNav__text" }, "显示导航栏", -1)
const _hoisted_5 = { class: "custom-h5__layout__showNav__text__r" }
const _hoisted_6 = {
  key: 0,
  class: "custom-h5__layout__title"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 导航栏位置 ")
const _hoisted_8 = { class: "custom-h5__layout__title__r" }
const _hoisted_9 = {
  key: 1,
  class: "custom-h5__layout__title"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 导航标签 ")
const _hoisted_11 = { class: "custom-h5__layout__title__r" }

import { onMounted, ref } from 'vue'
import { NTabs, NTabPane, NSwitch, NCollapse, NCollapseItem } from 'naive-ui'
import Icon from '@teams/common/components/icon'
import ThemeCase from './customComponents/themeCase.vue'
import customHide from './customComponents/customHide.vue'
import PopoverSelect from './customComponents/popoverSelect.vue'
import NewTheme from './customComponents/newTheme.vue'
import { useCustomePanal } from './useCustomePanal'
import usePreference from '@teams/common/hooks/usePreference'
import { h5CustomNavPositionList, h5CustomNavLayoutList } from './useData'
import { FileInfo } from 'naive-ui/es/upload/src/interface'
import { ICaseItem } from './pcCustom.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'h5Custom',
  setup(__props) {

const {
  H5CustomPanalProps,
  H5CustomThemeProps,
  handleLayoutChange,
  handleRefreshCustomTheme,
  handleSaveCustomTheme,
  handleThemeColorChange,
  h5Preference
} = useCustomePanal('h5')

const { current, themeList } = usePreference()
const defaultShow = ref('layout')
const showNavSwitch = ref(H5CustomPanalProps.value.showNavBar)
const isCreateNewTheme = ref(false)
const currentItem = ref<ICaseItem>({
  key: '',
  name: ''
})
const handleShowNavSwitchChange = (value: boolean) => {
  handleLayoutChange('showNavBar', value.toString())
}

const handleChangeUpload = (options: { file: FileInfo }) => {
  options.file.file && h5Preference.cropThemeBackgroundByFile(options.file.file)
}

const updateIsCreateNewTheme = (val: boolean) => {
  isCreateNewTheme.value = val
}

// 新建模板
const handleCreateNewTheme = () => {
  updateIsCreateNewTheme(true)
}
const emitBack = () => {
  isCreateNewTheme.value = false
  defaultShow.value = 'theme'
}
// 更改当前主题
const updateCurrentTheme = (item: ICaseItem) => {
  currentItem.value = item
}
onMounted(() => {
  themeList.forEach(item => {
    if (item.key === current.theme.key) {
      currentItem.value = item
    }
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isCreateNewTheme.value)
      ? (_openBlock(), _createBlock(_unref(NTabs), {
          key: 0,
          "default-value": defaultShow.value,
          animated: "",
          class: "tab",
          "justify-content": "space-evenly"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(NTabPane), {
              name: "layout",
              tab: "布局",
              "display-directive": "show"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(NCollapse), {
                    "default-expanded-names": ['pageHead', 'navOps'],
                    "display-directive": "show"
                  }, {
                    arrow: _withCtx(() => [
                      _createVNode(_unref(Icon), { name: "collapseArrow" })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(NCollapseItem), {
                        title: "页头",
                        name: "pageHead"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(customHide, {
                            "member-avatar-checked": !_unref(H5CustomPanalProps).showTeamAvatar,
                            "message-notification-checked": !_unref(H5CustomPanalProps).showMessage,
                            "team-memory-checked": !_unref(H5CustomPanalProps).showTeamMemory,
                            "sharing-team-checked": !_unref(H5CustomPanalProps).showTeamShare,
                            onTeamMemoryCheckedChange: _cache[0] || (_cache[0] = (v) => _unref(handleLayoutChange)('showTeamMemory',(!v).toString())),
                            onMemberAvatarCheckedChange: _cache[1] || (_cache[1] = (v) => _unref(handleLayoutChange)('showAvatarGroup',(!v).toString())),
                            onMessageNotificationCheckedChange: _cache[2] || (_cache[2] = (v) => _unref(handleLayoutChange)('showMessageButton',(!v).toString())),
                            onSharingTeamCheckedChange: _cache[3] || (_cache[3] = (v) => _unref(handleLayoutChange)('showShareButton',(!v).toString()))
                          }, null, 8, ["member-avatar-checked", "message-notification-checked", "team-memory-checked", "sharing-team-checked"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(NCollapseItem), {
                        title: "导航栏",
                        name: "navOps"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("span", _hoisted_5, [
                              _createVNode(_unref(NSwitch), {
                                value: showNavSwitch.value,
                                "onUpdate:value": [
                                  _cache[4] || (_cache[4] = ($event: any) => ((showNavSwitch).value = $event)),
                                  handleShowNavSwitchChange
                                ]
                              }, null, 8, ["value"])
                            ])
                          ]),
                          (showNavSwitch.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _hoisted_7,
                                _createElementVNode("span", _hoisted_8, [
                                  _createVNode(PopoverSelect, {
                                    customList: _unref(h5CustomNavPositionList),
                                    "init-key": _unref(H5CustomPanalProps).navBarPosition
                                  }, null, 8, ["customList", "init-key"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (showNavSwitch.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _hoisted_10,
                                _createElementVNode("span", _hoisted_11, [
                                  _createVNode(PopoverSelect, {
                                    customList: _unref(h5CustomNavLayoutList),
                                    "init-key": _unref(H5CustomPanalProps).navBarContentLayout
                                  }, null, 8, ["customList", "init-key"])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_unref(NTabPane), {
              name: "theme",
              tab: "主题",
              "display-directive": "show"
            }, {
              default: _withCtx(() => [
                _createVNode(ThemeCase, {
                  onHandleCreateNewTheme: handleCreateNewTheme,
                  onUpdateCurrentTheme: updateCurrentTheme
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["default-value"]))
      : (_openBlock(), _createBlock(NewTheme, {
          key: 1,
          onBack: emitBack,
          onOnThemePanelChange: _unref(handleThemeColorChange),
          onOnRefresh: _unref(handleRefreshCustomTheme),
          onOnSave: _unref(handleSaveCustomTheme),
          onOnChangeUpload: handleChangeUpload,
          "custom-theme-props": _unref(H5CustomThemeProps),
          isPcCustom: false,
          currentItem: currentItem.value,
          showNavSwitch: _unref(H5CustomPanalProps).showNavBar
        }, null, 8, ["onOnThemePanelChange", "onOnRefresh", "onOnSave", "custom-theme-props", "currentItem", "showNavSwitch"]))
  ]))
}
}

})